export function optimizeFilter<T extends Record<string, any>>(params: T): Required<T> {
  for (const key of Object.keys(params)) {
    if (params[key] === undefined || params[key] == null || params[key] === '') {
      delete params[key];
    }
  }
  return params as Required<T>;
}
